import { Skeleton } from 'antd';
import { NftDescriptionSkeleton } from 'components/Shared/NftDescription/Skeleton';
import { NftPropertiesHistorySkeleton } from 'components/Shared/NftPropertiesHistory/Skeleton';
import { NftPurchaseBlockSkeleton } from 'components/Shared/NftPurchaseBlock/Skeleton';
import * as Styled from './styles';

export const NftViewDesktopSkeleton = () => {
  return (
    <Styled.NftPage>
      <Styled.NftPageLeftSide>
        <Styled.NftMediaSkeleton />
        <NftPropertiesHistorySkeleton />
        <Styled.BlankSpace />
      </Styled.NftPageLeftSide>
      <Styled.NftPageRightSide>
        <Styled.FlexBlock $gap={24}>
          <Styled.NftAvatarBlockSkeleton size="large" reverseText />
          <Styled.NftAvatarBlockSkeleton size="large" reverseText />
          <Skeleton.Button
            active
            style={{
              borderRadius: 12,
              height: '44px',
              width: '108px'
            }}
          />
        </Styled.FlexBlock>
        <Styled.NftTitle>
          <Skeleton.Button
            block
            active
            style={{
              height: '32px',
              width: '80%',
              margin: '2 0'
            }}
          />
        </Styled.NftTitle>
        <NftDescriptionSkeleton />
        <NftPurchaseBlockSkeleton />
        <Styled.BlankSpace />
      </Styled.NftPageRightSide>
    </Styled.NftPage>
  );
};
